

























































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Site } from "@/shared/Site";
import LocalChooser from "@/components/localChooser.vue";
import { Enseigne } from "@/shared/Enseigne";

@Component({ components: { LocalChooser } })
export default class SelectedSites extends Vue {
  public restaurantIds_to_enseigne: any = {};
  public lSites: Site[] = [];

  @Prop({ default: false }) public onMobile!: boolean;
  @Prop({ default: false }) public isFavoris!: boolean;
  @Prop({ default: false }) public showVendeurs!: boolean;
  @Prop({ default: () => new Set<number>() })
  public resIdSelected!: Set<number>;

  public showDial = false;

  public remSiteFromDial(site: Site) {
    this.resIdSelected.delete(site.restaurantId);
    this.updateLSites();
    this.$emit("removeSite", site);
  }

  public mounted() {
    this.updateLSites();
  }

  @Watch("resIdSelected", { immediate: true })
  public onPropertyChanged(value: any, oldValue: any) {
    this.updateLSites();
  }

  /*
   * methode de mise a jour de la liste des caisses depuis le composant vers la page qui l'affiche
   */
  public updateCaisses(listeCaisses: any) {
    this.$emit("updateCaisses", listeCaisses);
  }

  public updateVendeur(vendeur: string) {
    this.$emit("updateVendeur", vendeur);
  }
  public created() {
    const enseignes = this.enseignes;
    enseignes.forEach((enseigne: Enseigne) => {
      this.restaurantIds_to_enseigne[enseigne.restaurantId] = enseigne.libelle;
    });
  }

  public updateLSites() {
    this.lSites = this.getSites.filter((site) =>
      this.resIdSelected.has(site.restaurantId)
    );
  }

  get getSites(): Site[] {
    return this.$store.getters["login/sites"];
  }

  get enseignes(): any {
    return this.$store.getters["login/enseignes"];
  }
  get rap(): any {
    let rap;
    if (this.isFavoris) {
      rap = this.$store.getters["rapport/selectedFavoris"];
    } else {
      rap = this.$store.getters["rapport/rapport"];
    }
    return rap;
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
